// extracted by mini-css-extract-plugin
export var fadeIn = "_ho-1";
export var modalContent = "_ho-3";
export var overlay = "_ho-0";
export var popoverContent = "_ho-2";
export var results = "_ho-5";
export var searchInputWrapper = "_ho-4";